import { useState, useEffect } from 'react';

const useWindowWidth = () => {
  const isBrowser = typeof window !== 'undefined';
  const [windowWidth, setWindowWidth] = useState<number>(
    isBrowser ? window.innerWidth : 0
  );

  useEffect(() => {
    if (!isBrowser) return;

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isBrowser]); // Ensure effects only run in browser

  return windowWidth;
};

export default useWindowWidth;
